import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

const About = () => {
  const { t, lang } = useI18n();
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-12">
      <div className="font-mono text-xs tracking-widest text-[#FF3B30] mb-3">// ABOUT</div>
      <h1 className="font-heading text-4xl md:text-5xl mb-6">
        {lang === "ro" ? "Despre Sports Nutrition Engine" : "About Sports Nutrition Engine"}
      </h1>
      <div className="space-y-5 text-white/80 leading-relaxed">
        {lang === "ro" ? (
          <>
            <p>
              Sports Nutrition Engine este o platformă de planificare nutrițională construită
              cu precizie, de la zero, pentru sportivi profesioniști și antrenorii lor.
            </p>
            <h2 className="font-heading text-2xl text-white pt-3">Metodologie</h2>
            <p>
              Toate calculele se bazează pe literatura recunoscută de nutriție sportivă:
              formula Mifflin-St Jeor pentru BMR, factori de activitate calibrați per sport și post,
              recomandări de macros pe greutate corporală (g/kg), și un strat de siguranță pentru
              sportivii sub 18 ani. Aplicația rulează rule-based, nu generează conținut prin AI.
            </p>
            <h2 className="font-heading text-2xl text-white pt-3">Cine suntem</h2>
            <p>
              Aplicația este dezvoltată și operată de <b>TriboiAI LLC</b>, reprezentată legal de
              Iulian Triboi. Adresă companie: pe cerere prin email.
            </p>
            <h2 className="font-heading text-2xl text-white pt-3">Disclaimer medical</h2>
            <p>
              Recomandările generate sunt informaționale și nu înlocuiesc consilierea unui medic
              sau nutriționist autorizat. Înainte de a începe orice protocol nou de suplimentare
              sau dietă consultă un specialist, mai ales dacă ai afecțiuni preexistente sau ești
              minor.
            </p>
            <h2 className="font-heading text-2xl text-white pt-3">Contact</h2>
            <p>
              Întrebări sau probleme tehnice:{" "}
              <a href="mailto:iuliantriboi@gmail.com" className="text-[#FF3B30] hover:underline">
                iuliantriboi@gmail.com
              </a>
            </p>
            <div className="mt-4 p-4" style={{ background: "#141414", border: "1px solid #27272A" }}>
              <div className="font-bold text-white mb-1">TRIBOIAI LLC</div>
              <div className="text-sm text-white/70">File No. 2026-001869654</div>
              <div className="text-sm text-white/70">1021 E Lincolnway Suite 9733, Cheyenne, WY 82001, USA</div>
              <div className="text-sm text-white/70">contact: iuliantriboi@gmail.com</div>
              <div className="text-xs text-white/40 mt-2">© 2026. All Rights Reserved.</div>
            </div>
          </>
        ) : (
          <>
            <p>
              Sports Nutrition Engine is a nutrition planning platform built with precision,
              from the ground up, for professional athletes and their coaches.
            </p>
            <h2 className="font-heading text-2xl text-white pt-3">Methodology</h2>
            <p>
              All calculations are based on established sports nutrition literature: the
              Mifflin-St Jeor BMR equation, sport- and position-calibrated activity factors,
              body-weight-relative macro recommendations (g/kg), and a built-in safety ceiling
              for athletes under 18. The engine is rule-based — no AI content generation.
            </p>
            <h2 className="font-heading text-2xl text-white pt-3">Who we are</h2>
            <p>
              The application is developed and operated by <b>TriboiAI LLC</b>, legally represented
              by Iulian Triboi. Company address available on request via email.
            </p>
            <h2 className="font-heading text-2xl text-white pt-3">Medical disclaimer</h2>
            <p>
              All recommendations are informational and do not replace advice from a licensed
              physician or sports dietitian. Before starting any new supplementation or diet protocol,
              consult a qualified professional — especially if you have pre-existing conditions or
              are under 18.
            </p>
            <h2 className="font-heading text-2xl text-white pt-3">Contact</h2>
            <p>
              Questions or technical issues:{" "}
              <a href="mailto:iuliantriboi@gmail.com" className="text-[#FF3B30] hover:underline">
                iuliantriboi@gmail.com
              </a>
            </p>
            <div className="mt-4 p-4" style={{ background: "#141414", border: "1px solid #27272A" }}>
              <div className="font-bold text-white mb-1">TRIBOIAI LLC</div>
              <div className="text-sm text-white/70">File No. 2026-001869654</div>
              <div className="text-sm text-white/70">1021 E Lincolnway Suite 9733, Cheyenne, WY 82001, USA</div>
              <div className="text-sm text-white/70">contact: iuliantriboi@gmail.com</div>
              <div className="text-xs text-white/40 mt-2">© 2026. All Rights Reserved.</div>
            </div>
          </>
        )}
        <Link to="/" data-testid="about-back-home">
          <button className="btn-secondary mt-6">← {t.common.back_home}</button>
        </Link>
      </div>
    </div>
  );
};

export default About;
